
const ES = {
    title: 'Datos',
    subTitles: {
        address: 'Domicilio',
        email: 'Correo',
        telephone: 'Nº de celular',
        device: 'Dispositivos'
    },
    subDescriptions: {
        address: 'Domicilio legal',
        email: 'Correo',
        telephone: 'Nº de celular'
    },
    inputs: {
        document: 'INE',
        cuit: 'RFC',
        nationality: 'Nacionalidad',
        gender: 'Género',
        birthdate: 'Fecha de nacimiento',
        level: 'Nivel',
        email: 'Correo',
        maritalStatus: 'Estado civil',
        dwellTime: 'Tiempo de casa',
        phoneNumber: 'Número de celular',
        profession: 'Ocupación',
        male: 'Masculino',
        female: 'Femenino',
        category: 'Categoría',
        recipient: 'Destinatario',
        title: 'Título',
        subtitle: 'Subtítulo',
        description: 'Descripción',
        publishDate: 'Fecha y hora de publicación',
    },
    subInputs: {
        address: 'Domicilio legal',
        country: 'Pais',
        province: 'Provincia',
        location: 'Localidad',
        street: 'Calle',
        zipCode: 'Código Postal'
    },
    realAddressInputs: {
        address: 'Domicilio real',
        country: 'Pais',
        province: 'Provincia',
        location: 'Localidad',
        streetAddr: 'Calle',
        streetNum: 'Número de calle',
        floor: 'Piso',
        dept: 'Departamento',
        zipCode: 'Código Postal'
    },
    extra: {
        title: 'Otros datos',
        subject: 'Sujeto obligado'
    },
    civilStatus: {
        married: 'Casado',
        single: 'Soltero',
        concubinage: 'Convivencia'
    },
    level: {
        diamond: 'Diamante',
        sapphire: 'Zafiro',
        golden: 'Oro',
        silver: 'Plata',
        bronze: 'Bronce'
    },
    dialog: {
        block: {
            title: 'Bloqueo de cliente',
            description: 'Se va a bloquear al cliente ',
        },
        pin: {
            title: 'Desbloqueo de cliente',
            description: {
                0: 'enviar el pin al ',
                1: 'Verifica que el número sea correcto.'
            }
        },
        recoverPassword: {
            title: 'Recuperar contraseña',
            description: {
                0: 'Se va a enviar un e-mail al cliente ',
                1: 'con el link de recupero de contraseña.',
            }
        },
        alert: {
            userBlocked: 'El usuario fue bloqueado correctamente.',
            activateError: 'Error activando usuario.',
            sendPin: 'Se reenvió el PIN de desbloqueo correctamente.',
            pinSuccess: 'Se cambio el estado del cliente, a recuperado, correctamente y se envio el PIN de desbloqueo.',
            invalidPhone: 'El número de teléfono es inválido.',
            validationSuccess: 'La validación del cliente fue correcta.',
            mailSuccess: 'El mail fue enviado correctamente.',
            invalidMail: 'El email es inválido.',

        },
        blockPaymentLink: {
            title: '¿Desea bloquear la generación de\nlinks de pago para',
        },
        unblockPaymentLink: {
            title: '¿Desea habilitar la generación de\nlinks de pago para',
        }
    },
    alert: {
        userBlocked: 'El usuario ha sido bloqueado exitosamente.',
        activateError: 'Error al intentar activar al usuario.',
        sendPin: 'El PIN de desbloqueo ha sido enviado correctamente.',
        pinSuccess: 'El estado del usuario ha cambiado a Recupero y el PIN de desbloqueo ha sido enviado.',
        blockPaymentLink: 'El estado de la generación ha cambiado.',
        errorBlockPaymentLink: 'Error al cambiar el estado.',
        invalidPhone: 'Número de teléfono inválido.',
        validationSuccess: 'La validación del cliente se aplicó correctamente.',
        mailSuccess: 'El correo electrónico se ha enviado exitosamente.',
        invalidMail: 'La dirección de correo electrónico es invalida.'
    }
};

export default ES;
